module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8OqVC"))).then(() => parcelRequire('d0iPb'));